
import PropTypes from "prop-types";
import { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  List,
  ListItem,
  ListItemText
} from "@mui/material";

import { useAuth } from "../../../context/AuthProvider"


function Password({
  label,
  inputLabel,
  formState,
  setFormState,
  setFormError,
}) {
  const [ value, setValue ] = useState("");

  function onChange(e) {
    const inputValue = e.target.value;
    let inputValid = true;

    if (inputValid) {
      setValue(inputValue);
      setFormState({
        ...formState,
        [e.target.name]: inputValue,
      });
      setFormError(null);
    }
  }

  return (
    <Box id="password">
      <Typography
        id='passwordLabel'
        component='label'
        htmlFor='passwordInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <TextField
        id='passwordInput'
        margin='dense'
        required
        fullWidth
        label={inputLabel}
        name='password'
        type="password"
        onChange={onChange}
        value={value}
      />
    </Box>
  );
};

const validatePassword = (password) => {
  // Validation rules
  const MAX_LENGTH = 10;
  const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
  const lowercaseCharRegex = /[a-z]/;
  const uppercaseCharRegex = /[A-Z]/;
  const numberCharRegex = /[0-9]/;

  let passwordValid = false;

  if (
    password.length >= MAX_LENGTH &&
    specialCharRegex.test(password) &&
    lowercaseCharRegex.test(password) &&
    uppercaseCharRegex.test(password) &&
    numberCharRegex.test(password)
  ) {
    passwordValid = true;
  }

  return passwordValid;
};

function PasswordCriteria() {

  const { passwordCriteria } = useAuth();

  return (
    <>
      <Typography
        sx={{ fontWeight: "bold", mt: { xs: 4, md: 2 } }}
        component='label'
        htmlFor='passwordCriteria'
      >
        Password criteria
      </Typography>
      <List
        id="passwordCriteria"
        sx={{ listStyleType : 'disc', ml: 2.5 }}
      >
        {passwordCriteria.map((item) => (
          <ListItem
            key={item.id}
            disablePadding
            sx={{ display: 'list-item' }}
          > 
            <ListItemText primary={item.rule} />
          </ListItem>))}
      </List>
    </>
  );
};

Password.propTypes = {
  label: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
};

export { Password, validatePassword, PasswordCriteria };